import { render } from "./navComponent.vue?vue&type=template&id=84a4004e"
import script from "./navComponent.vue?vue&type=script&lang=js"
export * from "./navComponent.vue?vue&type=script&lang=js"

import "./navComponent.vue?vue&type=style&index=0&id=84a4004e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__